import script from "./AssetsByCategoryReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsByCategoryReport.vue?vue&type=script&setup=true&lang=js"

import "./AssetsByCategoryReport.vue?vue&type=style&index=0&id=5e42aa5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e42aa5b"]])

export default __exports__